import { BasketItem } from '@modules/checkout-store';
import { DeliveryMethod } from './delivery-method';

export interface IBasketItemForGtmCheckout extends BasketItem {
  deliveryMethod?: DeliveryMethod;
  isDirectDebit: boolean;
}
